import {
  all, takeLatest, select, call, put,
} from 'redux-saga/effects';

import { IAppStore } from '../types/IAppStore';
import {
  getWidgetsSettingsError,
  getWidgetsSettingsSuccess,
  updateWidgetsSettingsError,
  updateWidgetsSettingsSuccess
} from '../actions/restaurantsWidgetsSettings/RestaurantsWidgetsSettingsActions';
import * as ActionTypes from '../actions/restaurantsWidgetsSettings/RestaurantsWidgetsSettingsTypes';
import {
  getWidgetsSettingsReq,
  updateWidgetsSettingsReq,
} from '../api';
import { IUpdateWidgetsSettings } from '../actions/restaurantsWidgetsSettings/IRestaurantsWidgetsSettingsActions';

function* updateWidgetsSettingsSaga(action: IUpdateWidgetsSettings) {
  const currentRestaurant = yield select((state: IAppStore) => state.cabinet.currentRestaurant);
  try {
    const settings = yield call(updateWidgetsSettingsReq, currentRestaurant.id, action.payload);
    yield put(updateWidgetsSettingsSuccess(settings));
  } catch (e) {
    yield put(updateWidgetsSettingsError());
  }
}

function* getWidgetsSettingsSaga() {
  const currentRestaurant = yield select((state: IAppStore) => state.cabinet.currentRestaurant);
  try {
    const settings = yield call(getWidgetsSettingsReq, currentRestaurant.id);
    yield put(getWidgetsSettingsSuccess(settings));
  } catch (e) {
    yield put(getWidgetsSettingsError());
  }
}

export default function* saga() {
  yield all([
    takeLatest(ActionTypes.UPDATE_WIDGETS_SETTINGS_REQUEST, updateWidgetsSettingsSaga),
    takeLatest(ActionTypes.GET_WIDGETS_SETTINGS_REQUEST, getWidgetsSettingsSaga),
  ]);
}
